"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContent = exports.Full = exports.StyledSection = exports.Backdrop = exports.Absolute = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
exports.Wrap = app_1.styled.div `
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  height: 100%;
  z-index: 50;
`;
exports.Absolute = app_1.styled.div `
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 25;
  overflow: hidden;
`;
exports.Backdrop = app_1.styled.div `
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;

  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;
exports.StyledSection = app_1.styled.section `
  position: absolute;
  right: ${(_t, { $position }) => ($position === 'right' ? '0px' : 'unset')};
  left: ${(_t, { $position }) => ($position === 'left' ? '0px' : 'unset')};
  top: 0px;
  bottom: 0px;
  max-width: 100%;
  display: flex;
  z-index: 1;
`;
exports.Full = app_1.styled.div `
  height: 100%;
  max-width: ${(_, { $noMaxWidth }) => ($noMaxWidth ? 'unset' : '28rem')};
`;
exports.DrawerContent = app_1.styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${(theme) => theme.background};
  overflow-y: auto;
  overflow-x: hidden;
`;
